// extracted by mini-css-extract-plugin
export default {"distribute_footer":"DistributeFooter_distribute_footer__rwm3s"};